import React from "react";
import { Wrapper, Image } from "./styled";
import RelationShipFolder from "../../../../images/relationshipFolder.svg";

const RelationShipFolderIcon = () => {
  return (
    <Wrapper>
      <Image src={RelationShipFolder} alt="icon" />
    </Wrapper>
  );
};

export default RelationShipFolderIcon;
